import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AuthProfileComponent } from './components/auth-profile.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    AuthProfileComponent
  ]
})
export class AuthModule { }
